import { Link } from '@online-webinar/ui-frontend';

export const VerificationFailed = () => {
    return (
        <>
            <div className="text-xl">Please log in to your account to resend a verification email!</div>
            <div className="my-4">
                <Link to="/login" variant="primary">
                    Login
                </Link>
            </div>
        </>
    );
};
